import { render } from "./AdminYellowCompanyUpdate.vue?vue&type=template&id=66e3bb14"
import script from "./AdminYellowCompanyUpdate.vue?vue&type=script&lang=js"
export * from "./AdminYellowCompanyUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__